var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$store.getters['nav/show'])?_c('Navigation'):_vm._e(),_c('loader',{class:{'loader-hidden': !_vm.$store.getters['loader/show']}}),_vm._t("default"),_c('Footer')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }